// Check if device supports vibration
const isVibrationSupported = () => {
    return "vibrate" in navigator;
  };
  
  // Check if device is mobile
  const isMobileDevice = () => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  };
  
  // Haptic patterns (in milliseconds)
  export const HapticPatterns = {
    LIGHT: 25,           // Light tap - for hover/selection
    MEDIUM: 40,          // Medium tap - for button clicks
    HEAVY: 60,           // Heavy tap - for important actions
    SUCCESS: [30, 50, 30],   // Success pattern - for confirmations
    ERROR: [50, 50, 50], // Error pattern - for errors
    SELECTION: 30,       // Item selection
    SWIPE: 20,            // Swipe feedback
  };
  
  // Main haptic trigger function
  export const triggerHaptic = (pattern = HapticPatterns.MEDIUM) => {
    // Only trigger on mobile devices with vibration support
    if (!isMobileDevice() || !isVibrationSupported()) {
      return;
    }
  
    try {
      navigator.vibrate(pattern);
    } catch (error) {
      console.warn("Haptic feedback failed:", error);
    }
  };
  
  // Easy-to-use haptic functions
  const haptics = {
    // Light feedback - for navigation, category selection
    light: () => triggerHaptic(HapticPatterns.LIGHT),
    
    // Medium feedback - for button clicks, tab switches
    medium: () => triggerHaptic(HapticPatterns.MEDIUM),
    
    // Heavy feedback - for important actions like KOT, checkout
    heavy: () => triggerHaptic(HapticPatterns.HEAVY),
    
    // Success feedback - for successful operations
    success: () => triggerHaptic(HapticPatterns.SUCCESS),
    
    // Error feedback - for errors
    error: () => triggerHaptic(HapticPatterns.ERROR),
    
    // Selection feedback - for selecting items
    selection: () => triggerHaptic(HapticPatterns.SELECTION),
    
    // Swipe feedback - for drawer open/close
    swipe: () => triggerHaptic(HapticPatterns.SWIPE),
  };
  
  export default haptics;